import { Autocomplete, TextField } from '@mui/material';

import { usePacksList } from '../hooks/packs';

export interface PackInputProps {
    value: string;
    onChange: (value: string) => void;
}

export const PackInput = (props: PackInputProps) => {
    const { packs } = usePacksList({ enabled: true });

    const isInvalid = props.value
        ? !packs?.some((pack) => pack.packId === props.value)
        : false;
    const errorMessage = `'${props.value}' is not a valid pack.`;

    return (
        <Autocomplete
            options={packs?.map((pack) => pack.packId) ?? []}
            value={props.value}
            freeSolo
            autoSelect
            onChange={(_, value) => {
                if (value) {
                    props.onChange(value);
                } else {
                    props.onChange('');
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Pack Id"
                    error={isInvalid}
                    helperText={isInvalid ? errorMessage : undefined}
                    slotProps={{
                        ...params.slotProps,
                        input: {
                            ...params.slotProps?.input,
                            type: 'search',
                        },
                    }}
                />
            )}
            color={isInvalid ? 'warning' : 'default'}
        />
    );
};
